import Vue from 'vue';

export default function Window(window) {
  const vm = new Vue({
    data: {
      innerHeight: 0,
      innerWidth: 0,
      mouseX: 0,
      mouseY: 0,
    },

    watch: {
      innerWidth() {
        this.$emit('resize');
      },

      innerHeight() {
        this.$emit('resize');
      },
    },
  });

  function updateSize() {
    vm.innerWidth = window.innerWidth;
    vm.innerHeight = window.innerHeight;
  }

  function updateMousePosition(event) {
    vm.mouseX = event.clientX || event.screenX;
    vm.mouseY = event.clientY || event.screenY;
  }

  window.addEventListener('resize', updateSize);
  window.addEventListener('mousemove', updateMousePosition);

  updateSize();

  return vm;
}



// WEBPACK FOOTER //
// ./src/Window.js